<template>
    <div class="text-center pb-0 " >
        <v-dialog v-model="xlsExeFlag" width="400">
            <v-card class="pb-5">
                <v-card-title class="text-subtitle-1 pb-0 mb-0">
                    <h4>Select Excel File</h4>
                </v-card-title>
                <v-card-text class="pb-0 mt-5 mb-0">
                    <div >
                        <v-file-input  :rules="upRules" label="File input" outlined dense show-size truncate-length="40" accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ></v-file-input>
                    </div>
                </v-card-text>
                <v-card-actions class="justify-end pb-2">
                    <v-btn dark class="backBtn px-5"  @click="xFileUploadClose" >Cancel</v-btn>
                    <v-btn dark class="registerBtn ml-2 px-6" @click="regFileInfo()">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
  export default {
    name: 'xlsUploader',
    props: {xlsExeFlag: Boolean }, 
    data: () => ({
        upRules: [
            value => !value || value.size < 2000000 || 'Upload Files should be less than 2MB !'
        ]
    }),
    methods: {
        xFileUploadClose() {
            console.log('a');
            this.$emit("xFileUploadClose");
        },
        regFileInfo() {
             this.$emit("xFileUpload");
        }

    }
  }
</script>